import { NextCustomImage } from 'components/Image';
// import { ARTICLE_CARD_TEST_IDS } from 'constants/testsIds/articleComponents';
import type { MediaItem } from 'interfaces/content/Media';
import RawHtml from 'utils/miscUtils/rawHtml';
import cn from 'classnames';
import * as S from './TopicHeroStyles';
import getCommonTestId from 'constants/testsIds/common';

export interface TopicHeroProps {
  headline?: string;
  description?: string;
  image?: MediaItem | string | null;
}

const TopicHero = ({ headline, description, image }: TopicHeroProps) => (
  <S.Container>
    {image && typeof image !== 'string' && image?.mediaItemUrl && (
      <NextCustomImage
        data-cy={getCommonTestId('TOPIC_PAGE_HERO_IMAGE')}
        width={300}
        height={300}
        src={typeof image === 'string' ? image : image?.mediaItemUrl}
        alt={typeof image !== 'string' && image?.altText ? image.altText : 'alt text'}
        className='image-link'
      />
    )}
    <S.ContentWrapper>
      {headline && (
        <S.Title
          as='h1'
          $fontFamily='saol'
          $size={{ default: 'level2', lgMin: 'large', mdMin: 'level1' }}
          className={cn('child-content', description !== '')}
        >
          {headline}
        </S.Title>
      )}
      {description && (
        <S.DescriptionWrapper
          className={cn('child-content', headline !== '')}
          data-cy={getCommonTestId('TOPIC_PAGE_HERO_DESC')}
        >
          {RawHtml({ html: description })}
        </S.DescriptionWrapper>
      )}
    </S.ContentWrapper>
  </S.Container>
);
export default TopicHero;
